module.exports = __webpack_public_path__ + "img/wechat@2x.8ff0e9da.png";